exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.radius[data-v-71906bd6] {\r\n  border-radius: 50%;\n}\n.pl8[data-v-71906bd6] {\r\n  padding-left: 8px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/distribution/promote/index.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB","file":"index.vue","sourcesContent":["\n.radius[data-v-71906bd6] {\r\n  border-radius: 50%;\n}\n.pl8[data-v-71906bd6] {\r\n  padding-left: 8px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71906bd6","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/distribution/promote/index.vue
// module id = MxIv
// module chunks = 0